import { MDSPlanId } from "../plan-card.types";
import { StyledFeatureRow, StyledPlanCardFeatures } from "./plan-card-features.styles";
import { MDSText, MDSTextVariant } from "@/mds/components/text";
import { MDSIcon, MDSIconColor, MDSIconKind } from "@/mds/components/icon";

interface MDSPlanCardFeaturesProps {
  plan: MDSPlanId;
  labels: string[];
}

export const MDSPlanCardFeatures = ({ plan, labels }: MDSPlanCardFeaturesProps) => {
  return (
    <StyledPlanCardFeatures>
      {labels.map(label => (
        <StyledFeatureRow key={label}>
          <MDSIcon
            kind={MDSIconKind.Check}
            size={16}
            color={plan === MDSPlanId.Paid ? MDSIconColor.Selected : MDSIconColor.Secondary}
          />
          <MDSText variant={MDSTextVariant.TextS}>{label}</MDSText>
        </StyledFeatureRow>
      ))}
    </StyledPlanCardFeatures>
  );
};
